<template>
  <div>
    <v-card flat color="transparent" class="pb-6">
      <v-skeleton-loader type="heading"></v-skeleton-loader>
    </v-card>

    <v-card flat outlined color="transparent" class="pb-10">
      <v-card-text class="pa-0">
        <v-skeleton-loader type="article"></v-skeleton-loader>
      </v-card-text>
    </v-card>

    <v-card flat color="transparent" class="pb-6">
      <v-skeleton-loader type="heading"></v-skeleton-loader>
    </v-card>

    <v-card flat color="transparent">
      <v-row class="d-flex">
        <v-col cols="6">
          <v-card outlined>
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card outlined>
            <v-skeleton-loader type="article"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ProjectLoading'
}
</script>
